import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "17 hour workday Sunday",
  "description": "",
  "published": "2008-10-06T00:00:00.000Z",
  "redirect_from": ["/blog/17-hour-workday-sunday/swizec/61"],
  "categories": "blog, life, tired, work",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Yesterday was the busiest Sunday I've had in a long while since usually I devote my Sundays to leisurely activities with my girlfriend. This weekend however the girlfriend went on a trip to Tirol with family and I seized the day (and night actually) to remake my blog - something I've been planning to do for several months, but never quite got around to.`}</p>
    <p>{`So on Saturday I started working on the software part of everything, some modules needed an upgrade or two, a touch up here and there and certain things I had to develop from scratch. Ten hours later, at around three in the morning, that bit was done, time for shuteye. And then came The Sunday. Got up and almost immediately started working. Set up my scanner, scanned in my notebook, torn pieces of paper, torn up sketches and other stuff that I needed.`}</p>
    <p>{`And so, at six in the morning, a full `}<strong parentName="p">{`seventeen`}</strong>{` hours later, the blog was complete, uploaded and quite functional. This was the first time I ever achieved anything like this on such a short timescale, then again, usually the designs I have to implement are quite more complex and tedious to make work. However most of my time was spent creating the images needed. For example photoshopping scanned in pages of writing onto torn paper (you can see the result bottom left) was especially difficult since I had to figure out how to do it in the first place. It turned out quite well if I do say so myself.`}</p>
    <p>{`Anyhow, over the next few days I'll be making touch ups to the design here and there, perhaps ironing out a bug or two and essentially making the whole thing even better. Bear with me please.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      